import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock, FaCheckCircle } from 'react-icons/fa';
import './Contact.css';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  const contactInfo = [
    { icon: FaMapMarkerAlt, title: "Address", lines: ["123 Luxury Boulevard", "Manhattan, New York, NY 10001"] },
    { icon: FaPhoneAlt, title: "Phone", lines: ["+1 (800) 555-1234", "+1 (212) 555-5678"] },
    { icon: FaEnvelope, title: "Email", lines: ["sales@rstechservices.in", "reservations@grandluxe.com"] },
    { icon: FaClock, title: "Front Desk", lines: ["Open 24 hours", "7 days a week"] },
  ];

  return (
    <main>
      <div className="page-banner">
        <div className="page-banner-content">
          <span className="section-badge">Get In Touch</span>
          <h1>Contact Us</h1>
          <p>We'd love to hear from you</p>
        </div>
      </div>

      <section className="section contact-page">
        <div className="container">
          <div className="contact-layout">
            <motion.div
              className="contact-info-col"
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <span className="section-badge">Reach Out</span>
              <h2 className="section-title" style={{ textAlign: 'left', marginBottom: '8px' }}>We're Here to Help</h2>
              <div className="gold-line" style={{ margin: '12px 0 24px' }} />
              <p style={{ color: 'var(--text-light)', lineHeight: 1.8, marginBottom: '40px' }}>
                Whether you have a question about a reservation, a special request, or would
                like to plan a bespoke experience, our team is always ready to assist.
              </p>

              <div className="contact-cards">
                {contactInfo.map(({ icon: Icon, title, lines }) => (
                  <div key={title} className="contact-info-card">
                    <div className="contact-info-icon"><Icon /></div>
                    <div>
                      <strong>{title}</strong>
                      {lines.map(l => <p key={l}>{l}</p>)}
                    </div>
                  </div>
                ))}
              </div>

              <div className="contact-map">
                <img
                  src="https://images.unsplash.com/photo-1568996235248-6a8d0aa3c6bd?w=600&q=80"
                  alt="Hotel location"
                  style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '12px' }}
                />
              </div>
            </motion.div>

            <motion.div
              className="contact-form-col"
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <div className="contact-form-card">
                <h3>Send Us a Message</h3>

                {submitted ? (
                  <motion.div
                    className="contact-success"
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                  >
                    <FaCheckCircle />
                    <h4>Message Sent!</h4>
                    <p>Thank you for reaching out. Our team will respond within 24 hours.</p>
                    <button className="btn btn-outline" onClick={() => setSubmitted(false)}>Send Another</button>
                  </motion.div>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <div className="contact-form-grid">
                      <div className="form-group">
                        <label>Full Name</label>
                        <input type="text" name="name" value={form.name} onChange={handleChange} placeholder="John Smith" required />
                      </div>
                      <div className="form-group">
                        <label>Email Address</label>
                        <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="john@example.com" required />
                      </div>
                      <div className="form-group">
                        <label>Phone Number</label>
                        <input type="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="+1 234 567 8900" />
                      </div>
                      <div className="form-group">
                        <label>Subject</label>
                        <select name="subject" value={form.subject} onChange={handleChange} required>
                          <option value="">Select subject</option>
                          <option value="reservation">Reservation Inquiry</option>
                          <option value="special">Special Request</option>
                          <option value="feedback">Feedback</option>
                          <option value="events">Events & Functions</option>
                          <option value="other">Other</option>
                        </select>
                      </div>
                      <div className="form-group form-group--full">
                        <label>Message</label>
                        <textarea name="message" value={form.message} onChange={handleChange} rows={5} placeholder="How can we help you?" required />
                      </div>
                    </div>
                    <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: '8px' }}>
                      Send Message
                    </button>
                  </form>
                )}
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </main>
  );
}
